import { createSlice } from '@reduxjs/toolkit';

export type notesState = {
  noteList: any[];
  channel_hash_id: string;
};

const initialState: notesState = { noteList: [], channel_hash_id: '' };

const notesSlice = createSlice({
  name: 'notes',
  initialState: initialState,
  reducers: {
    handleNoteList(state, action) {
      state.noteList = action.payload.noteList;
      state.channel_hash_id = action.payload.channel_hash_id;
    },
    addNote(state, action) {
      if (state.channel_hash_id === action.payload.channel_hash_id) {
        state.noteList = state.noteList.map((videoSlot: any) => {
          if (videoSlot.videoshot_hash_id === action.payload.note.shot_hash_id) {
            videoSlot.notes.push(action.payload.note);
            videoSlot.notes.sort((a: { time: number }, b: { time: number }) => a.time - b.time);
          }
          return videoSlot;
        });
      }
    }
  }
});

export const { handleNoteList, addNote } = notesSlice.actions;

export const notesReducer = notesSlice.reducer;
